var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NodeElement } from './base/node-element';
import * as _ from 'lodash';
import { DiagramConsts } from '../diagram-consts';
import * as go from '../../../../libs/gojs/release/go';
var HistoryCurveElement = /** @class */ (function (_super) {
    __extends(HistoryCurveElement, _super);
    function HistoryCurveElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoryCurveElement.prototype.compile = function (model, data, svg) {
        svg.empty();
        model['version'] = 4;
        var axisLabelFont = data.calibrationMarkSetting.showCalibration &&
            data.calibrationMarkSetting.showCalibrationDigit && data.calibrationMarkSetting.calibrationDigitFont ? {
            isUnderline: data.calibrationMarkSetting.calibrationDigitFont.isUnderline,
            isBold: data.calibrationMarkSetting.calibrationDigitFont.isBold,
            isItalic: data.calibrationMarkSetting.calibrationDigitFont.isItalic,
            fontSize: data.calibrationMarkSetting.calibrationDigitFont.fontSize,
            color: data.calibrationMarkSetting.calibrationDigitFont.color,
            textAlign: data.calibrationMarkSetting.calibrationDigitFont.textAlign
        } : undefined;
        var displaySetting = {
            size: this.sizeService.parse(data.size),
            location: go.Point.parse(data.loc),
            refreshInterval: data.generalSetting.refreshCycle * 60,
            displayTimePeriod: data.generalSetting.displayPeriod,
            showAxis: data.calibrationMarkSetting.showCalibration,
            axisSetting: data.calibrationMarkSetting && data.calibrationMarkSetting.showCalibration ? {
                axisColor: data.calibrationMarkSetting.calibrationColor,
                showAxisLabel: data.calibrationMarkSetting.showCalibrationDigit,
                axisLabelFont: axisLabelFont
            } : undefined,
            curveType: data.generalSetting.curveType
        };
        model['displaySetting'] = displaySetting;
        var channels = new Array();
        if (data.channelSetting && data.channelSetting.channelsData && data.channelSetting.channelsData.length) {
            _.each(data.channelSetting.channelsData, function (c) { return channels.push({
                name: c.channelName,
                connectorColor: c.lineColor,
                projectEnabled: c.projectionColor
            }); });
        }
        var dataSetting = data.channelSetting ? {
            dataSourceCode: data.channelSetting.dataSourceCode,
            dataName: data.channelSetting.historyDataName,
            channels: channels
        } : undefined;
        model['dataSetting'] = dataSetting;
    };
    HistoryCurveElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/history-curve-small.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    HistoryCurveElement.prototype.getDiagramTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', {
            resizable: true, locationObjectName: 'IMAGE', locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), 
        // can be resided according to the user's desires
        { resizable: true, resizeObjectName: 'IMAGE' }, $(go.Panel, 'Spot', $(go.Picture, {
            name: 'IMAGE',
            source: '/assets/common/images/configure/elements/history-curve-large.png'
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify))));
    };
    HistoryCurveElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.historyCurveKey;
    };
    return HistoryCurveElement;
}(NodeElement));
export { HistoryCurveElement };
